/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Connect_Rate_LimitedInputs */



/**
* | output |
* | --- |
* | "Too many connection attempts. Please try again later." |
*
* @param {Teams_Connect_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_connect_rate_limited = /** @type {((inputs?: Teams_Connect_Rate_LimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Connect_Rate_LimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu viele Verbindungsversuche. Bitte versuchen Sie es später erneut.")
	return /** @type {LocalizedString} */ ("Too many connection attempts. Please try again later.")
});